// 单位的全局混入
export default {
    // 这里的unit是store内的哈希表 由于其可以自定义 又在许多地方可以用到 故使用全局混入

    computed: {
        unit() {
            return this.$store.state.unit;
        }
    }
};
